module.exports = __webpack_public_path__ + "img/img_nav_bonus.91fb1f93.svg";